import { render, staticRenderFns } from "./MonitoringKebakaranDetail.vue?vue&type=template&id=73441489"
import script from "./MonitoringKebakaranDetail.vue?vue&type=script&lang=js"
export * from "./MonitoringKebakaranDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports